<template>
    <div>
        <div class="page-content-block email-alert">
            <div class="container">
                <div class="form-row">
                    <div class="col-12 mb-4">
                        <p>Please enter your email and select the notifications you would like to be unsubscribed
                            from.</p>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-12 col-lg-6">
                        <label>Email:</label>
                        <b-form-input type="email" class="form-control" v-model="form.email"
                                      v-on:focus.native="onFocus"
                                      :state="stateEmail" aria-describedby="input-3-live-feedback"></b-form-input>
                        <b-form-invalid-feedback id="input-3-live-feedback">
                            {{error.email}}
                        </b-form-invalid-feedback>
                    </div>
                </div>
                <div class="form-row mt-5">
                    <div class="form-group col-12">
                        <h4></h4>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-12 col-md-6 col-lg-3">
                        <h5>Company information</h5>
                        <div class="custom-control custom-checkbox" style="padding-left: 0px">
                            <b-form-checkbox
                                    id="checkbox-1"
                                    v-model="allPressRelease"
                                    name="checkbox-1"
                                    value="false"
                                    unchecked-value="true">
                                All press releases
                            </b-form-checkbox>
                        </div>
                    </div>
                    <div class="form-group col-12 col-md-6 col-lg-3">
                        <h5>SEC filings</h5>
                        <div class="custom-control custom-checkbox" style="padding-left: 0px">
                            <b-form-checkbox
                                    id="checkbox-2"
                                    v-model="allSecFilings"
                                    name="checkbox-2"
                                    value="false"
                                    unchecked-value="true">
                                All SEC filings
                            </b-form-checkbox>
                        </div>
                        <div class="custom-control custom-checkbox" style="padding-left: 0px">
                            <b-form-checkbox
                                    id="checkbox-3"
                                    v-model="annualQuarterlyReport"
                                    name="checkbox-3"
                                    value="false"
                                    unchecked-value="true">
                                Annual & quarterly reports
                            </b-form-checkbox>
                        </div>
                        <div class="custom-control custom-checkbox" style="padding-left: 0px">
                            <b-form-checkbox
                                    id="checkbox-4"
                                    v-model="currentReport"
                                    name="checkbox-4"
                                    value="false"
                                    unchecked-value="true">
                                Current report
                            </b-form-checkbox>
                        </div>
                        <div class="custom-control custom-checkbox" style="padding-left: 0px">
                            <b-form-checkbox
                                    id="checkbox-5"
                                    v-model="insiderTransaction"
                                    name="checkbox-5"
                                    value="false"
                                    unchecked-value="true">
                                Insider transactions
                            </b-form-checkbox>
                        </div>
                        <div class="custom-control custom-checkbox" style="padding-left: 0px">
                            <b-form-checkbox
                                    id="checkbox-6"
                                    v-model="proxyInformation"
                                    name="checkbox-6"
                                    value="false"
                                    unchecked-value="true">
                                Proxy information
                            </b-form-checkbox>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-12">
                        <b-button :disabled="showLoader" type="submit" class="btn btn-learnMore2" @click="submit">
                            <b-spinner style="margin-bottom: 3px" v-if="showLoader" small></b-spinner>
                            Submit
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import axios from 'axios'

    export default {
        props: {
            accountId: {
                type: String
            }
        },
        watch: {
            allSecFilings(val) {
                this.annualQuarterlyReport = val;
                this.currentReport = val;
                this.insiderTransaction = val;
                this.proxyInformation = val;
            }
        },
        data() {
            return {
                showLoader: false,
                contactTypeOptions: [
                    {value: 'Individual Investor', text: 'Individual Investor'},
                    {value: 'Analyst', text: 'Analyst'},
                    {value: 'Press/Media', text: 'Press/Media'},
                    {value: 'Portfolio Manager', text: 'Portfolio Manager'},
                ],
                allPressRelease: 'true',
                allSecFilings: 'true',
                annualQuarterlyReport: 'true',
                currentReport: 'true',
                insiderTransaction: 'true',
                proxyInformation: 'true',
                form: {
                    email: '',
                },
                valid: {
                    email: true,
                },
                error: {
                    email: 'Please enter valid email address',
                }
            }
        },
        computed: {
            stateEmail() {
                if (!this.valid.email) {
                    return false;
                }
                if (this.form.email.length === 0) {
                    return null
                }
                return this.isEmailValid(this.form.email);
            },
        },
        methods: {
            onFocus() {
                this.valid.email = true;
            },
            isEmailValid(email) {
                const emailRegexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/igm
                return emailRegexp.test(email);
            },
            async submit() {
                if (!this.stateEmail) {
                    this.valid.email = false;
                    return;
                }
                this.showLoader = true;
                this.form.allPressRelease = this.allPressRelease === 'true' ? undefined : false;
                this.form.allSecFilings = this.allSecFilings === 'true' ? undefined : false;
                this.form.annualQuarterlyReport = this.annualQuarterlyReport === 'true' ? undefined : false;
                this.form.currentReport = this.currentReport === 'true' ? undefined : false;
                this.form.insiderTransaction = this.insiderTransaction === 'true' ? undefined : false;
                this.form.proxyInformation = this.proxyInformation === 'true' ? undefined : false;
                await axios.post(`${this.accountId}/subscriber`, this.form);
                this.showLoader = false;
                this.$toasted.success('Unsubscribed Successfully', {duration: 3000});
                this.reset();
                window.scrollTo(0, 0);
            },
            reset() {
                this.allPressRelease = 'true';
                this.allSecFilings = 'true';
                this.annualQuarterlyReport = 'true';
                this.currentReport = 'true';
                this.insiderTransaction = 'true';
                this.proxyInformation = 'true';
                this.form = {
                    email: '',
                };
            }
        },
        mounted() {
            if (this.$route.query.emailId)
                this.form.email = this.$route.query.emailId;
        }
    }

</script>
